<template>
  <CardSection :error="majorError" :loading="isSavableStateLoading">
    <template #header>
      Manage Transplant Centers
    </template>
    <template #body>
      <PortalTable ref="transplant_centers_index" table-id="transplant_centers_index"
        :table-data="records"
        :total-records="totalRecords"
        :page="pageNumber"
        :page-count="pageCount"
        :loading="isSavableStateProcessing"
        :filter-values="filterValues"
        filter-display="row"
        empty="No TxC configurations found!"
        @on-sort="handleSortChange"
        @on-page="handlePageChange"
        @on-filter-change="onFilterChange">
        <template #columns>
          <Column field="code" 
            sort-field="transplant_center"
            header="TxC" 
            sortable
            filter-field="transplant_center_id"
            :show-filter-menu="false"
            :filter-menu-style="{ width: '15rem' }">
            <template #filter>
              <MultiSelectFilter ref="transplant_center_id" 
                filter-field="transplant_center_id"
                class="form-control form-control-select"
                :options="txcStore.transplantCenters"
                @change="onChange" />
            </template>
          </Column>
          <Column header="Actions">
            <template #body="slotProps">
              <router-link :to="{ name: 'admin_transplant_centers_edit', params: { id: slotProps.data.id } }"
                class="action btn btn-fill btn-outline-primary mx-2">
                Edit
              </router-link>
            </template>
          </Column>
        </template>
      </PortalTable>
    </template>
  </CardSection>
</template>

<script>
import CardSection from "@/src/components/shared/CardSection.vue";
import PortalTable from "@/src/components/shared/PortalTable.vue";
import Column from 'primevue/column';
import { savableStateMixin } from "@/src/mixins/savableStateMixin";
import { pageMixin } from "@/src/mixins/pageMixin";
import { FilterMatchMode } from '@primevue/core/api';
import MultiSelectFilter from "@/src/components/shared/FormComponents/MultiSelectFilter.vue";
import { useTxcStore } from '@/src/stores/transplant_centers';
import { paginationMixin } from "@/src/mixins/paginationMixin";

export default {
   components: {
    CardSection,
    PortalTable,
    Column,
    MultiSelectFilter
  },
  mixins: [ savableStateMixin, pageMixin, paginationMixin ],
  setup() {
    const txcStore = useTxcStore();
    return {
      txcStore
    }
  },
   data() {
    return {
      majorError: null,
      transplantCenters: null,
      filterValues: {
        "transplant_center_id" : { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        "organ_group_id" : { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      }
    }
  },
  async mounted() {
    try {
      this.setSavableStateLoading();
      await this.txcStore.loadTransplantCentres();
      this.setSavableStateIdle();
    } catch(error) {
      this.handleMajorError(error); 
    }
    this.getRowData();
  },
  methods: {
    async getRowData(reset = false) {
      this.setSavableStateProcessing();
      if (reset) this.pageNumber = 1;

      let params = {
        page: this.pageNumber,
        sort_by: this.currentSortField,
        sort_type: this.currentSortType,
      };

      params = { ...this.search_params, ...params };

      try {
        const response = await this.txcStore.loadAllTransplantCentres(params)
        this.processPagyResponse(response);
        this.setSavableStateIdle();
      } catch(error) {
      this.handleMajorError(error);  
      }
    },
    onChange(event) {
      this.$refs.transplant_centers_index.resetFilters(event);
    },
    onFilterChange(event) {
      if(event["transplant_center_id"] === "") this.$refs.transplant_center_id.clearFilters();

      this.search_params = event;
      this.getRowData(true);
    }
  }
}
</script>